import React, { Component, useReducer } from 'react';
import {Collapse, OverviewToggler,OverviewBrand,Nav,NavItem,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, Table, DropdownMenu, DropdownItem, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import {Triangle} from 'react-loader-spinner'
import Background_Image from '../images/image_3.jpg'

class PersonalTrainers extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
        super(props);
        this.state = {
            user_details: this.props.user_details,
            users: [],
            current_render: 'upload_video',
            name: '',
            fitness_goal: '',
            video: '',
            categories: [
                'Build Muscle', 'Loose Weight', 'Strength And Conditioning', 'Sports Perfomance', 'KickBoxing', 'Pilates', 'Spin Class', 'Toning',
                'Rehabilitation', 'Order Adults and Geriatic Care', 'Yoga', 'Wellness Monitoring'
            ],
            loading: true,
            list_in_view: 'all_users',
            all_users: true,
            trainers: false,
            admins: false,
            basic_plan_users: false,
            premium_plan_users: false,
            withdrawal_requests: []
        };

        this.HandleChange = (e) =>{
            this.setState({[e.target.name]: e.target.value});
        };

        this.UploadFile = (e) => {
          this.setState({[e.target.name]: e.target.files[0]})
        }

        this.ChangeRender = (new_render) => {
            this.setState({current_render: new_render})
        }

        this.ChangeListInView = (new_list) => {
            var old_list = this.state.list_in_view
            this.state[old_list] = false
            this.state[new_list] = true

            this.setState({list_in_view: new_list})
        }

        this.UploadVideo = () => {
            this.setState({loading: true})
            const { cookies } = this.props;
            var name = this.state.name
            var fitness_goal = this.state.fitness_goal
            var video = this.state.video

            var data = new FormData()
            data.append('user_access_token', cookies.get('token'))
            data.append('name', name)
            data.append('category', 'Home Videos')
            data.append('fitness_goal', fitness_goal)
            data.append('video', video)
    
            axios.post(Backend_Url + 'addVideo', data)
            .then((res) => {
                let result = res.data
                alert(name + ' added successfully.')
                this.setState({loading: false})
                window.location.reload()
            }).catch((error) => {
                alert('An error occured while trying to add ' + name + ', please check your data and try again.')
                this.setState({loading: false})
            })
        }

        this.SelectRender = () => {
            var current_render = this.state.current_render

            if (current_render == 'upload_video'){
                return<div>
                    <Row>
                        <Col>
                        <input name='name' value={this.state.name} onChange={this.HandleChange} type='text' placeholder='Workout Name'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                        </Col>
                        <Col>
                        <select name='goal' value={this.state.fitness_goal} onChange={this.HandleChange} type='text' placeholder='Workout Goal'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%', backgroundColor: 'inherit', marginTop: '7px'}}>
                            <option value=''>Select Fitness Goal</option>
                            {this.state.categories.map((category, index) => {
                                return<option value={category}>{category}</option>
                            })}
                        </select>
                        </Col>
                        <Col>
                        <p style={{marginTop: '-40px'}}>Select Video</p>
                        <Input name='video' onChange={this.UploadFile} type="file"
                        style={{backgroundColor: 'inherit', color: 'inherit'}}/>
                        </Col>
                    </Row>
                    <br/><br/>
                    <Row>
                        <Col>

                        </Col>
                        <Col>
                        <br/><br/><br/>
                        <Button onClick={this.UploadVideo} style={{border: 'none', backgroundColor: '#1faced', color: '#ffffff', width: '40%', borderRadius: '20px'}}>
                            Upload Video
                        </Button>
                        </Col>
                    </Row>
                </div>
            }else if (current_render == 'analytics'){
                var number_of_users = this.state.users.length
                var number_of_subscribed_users = this.state.users.filter(user => user.subscription_status == 'Subscribed').length
                var number_of_trainers = this.state.users.filter(user => user.role == 'trainer').length
                var number_of_admins = this.state.users.filter(user => user.role == 'admin').length

                return<div>
                    <Row>
                        <Col sm='3'>
                            <div style={{backgroundColor: '#1FACED', height: '150px', width: '150px', borderRadius: '50%'}}>
                                <Container style={{paddingTop: '15px'}}>
                                    <div style={{backgroundColor: '#FFFFFF', height: '120px', width: '120px', borderRadius: '50%'}}>
                                    <h3 style={{'paddingTop': '30px'}}>
                                        {number_of_users}
                                    </h3>
                                    <p>
                                        All Users
                                    </p>
                                    </div>
                                </Container>
                            </div>
                        </Col>
                        <Col sm='3'>
                            <div style={{backgroundColor: '#1FACED', height: '150px', width: '150px', borderRadius: '50%'}}>
                                <Container style={{paddingTop: '15px'}}>
                                    <div style={{backgroundColor: '#FFFFFF', height: '120px', width: '120px', borderRadius: '50%'}}>
                                    <h3 style={{'paddingTop': '30px'}}>
                                        {number_of_subscribed_users}
                                    </h3>
                                    <p>
                                        Subscribed Users
                                    </p>
                                    </div>
                                </Container>
                            </div>
                        </Col>
                        <Col sm='3'>
                            <div style={{backgroundColor: '#1FACED', height: '150px', width: '150px', borderRadius: '50%'}}>
                                <Container style={{paddingTop: '15px'}}>
                                    <div style={{backgroundColor: '#FFFFFF', height: '120px', width: '120px', borderRadius: '50%'}}>
                                    <h3 style={{'paddingTop': '30px'}}>
                                        {number_of_trainers}
                                    </h3>
                                    <p>
                                        Trainers
                                    </p>
                                    </div>
                                </Container>
                            </div>
                        </Col>
                        <Col sm='3'>
                            <div style={{backgroundColor: '#1FACED', height: '150px', width: '150px', borderRadius: '50%'}}>
                                <Container style={{paddingTop: '15px'}}>
                                    <div style={{backgroundColor: '#FFFFFF', height: '120px', width: '120px', borderRadius: '50%'}}>
                                    <h3 style={{'paddingTop': '30px'}}>
                                        {number_of_admins}
                                    </h3>
                                    <p>
                                        Admins
                                    </p>
                                    </div>
                                </Container>
                            </div>
                        </Col>
                    </Row>
                    <br/><br/><br/>
                    More site analytics available at Google Analytics under the Onfit account.
                    <br/>
                    Payment analytics available at Stripe.
                </div>
            }else if(current_render == 'user_lists'){
                var all_users = this.state.users
                var subscribed_users = this.state.users.filter(user => user.subscription_status == 'Subscribed')
                var trainers = this.state.users.filter(user => user.role == 'trainer')
                var admins = this.state.users.filter(user => user.role == 'admin')
                var users_on_basic_plan = this.state.users.filter(user => user.plan == 'Basic')
                var users_on_premium_plan = this.state.users.filter(user => user.plan == 'Premium')

                var list_in_view = this.state.list_in_view
                var users_to_list = []
                var label = ''

                if (list_in_view == 'all_users'){
                    users_to_list = all_users
                    label = 'All Users'
                }else if (list_in_view == 'trainers'){
                    users_to_list = trainers
                    label = 'Trainers'
                }else if (list_in_view == 'admins'){
                    users_to_list = admins
                    label = 'Admins'
                }else if (list_in_view == 'basic_plan_users'){
                    users_to_list = users_on_basic_plan
                    label = 'Users on Basic Plan'
                }else if (list_in_view == 'premium_plan_users'){
                    users_to_list = users_on_premium_plan
                    label = 'Users on Premium Plan'
                }  

                var user_list = users_to_list.map((user, index) => {
                    return<tr style={{borderBottom: '1px solid #1faced', fontSize: '13px'}}>
                        <td>{user.firstname}</td>
                        <td>{user.lastname}</td>
                        <td>{user.email}</td>
                        <td>{user.phonenumber}</td>
                        <td>{user.date_joined}</td>
                        {
                            label === 'Users on Basic Plan' 
                            ?<>
                                <td>{user.schedule}</td>
                                <td>{user.goals}</td>
                                <td>{user.methods}</td>
                            </>
                            : <>

                            </>
                        }
                        <td>
                            <Button onClick={() => this.DeleteAccount(user._id.$oid)} style={{color: '#ffffff', fontWeight: 'bold', fontSize: '13px', border: '3px solid red', borderRadius: '20px', backgroundColor: 'red'}}>
                                Delete Account
                            </Button>
                        </td>
                    </tr>
                })

                return<Container>
                    <Row>
                        <Col>
                            <Input type="checkbox" checked={this.state.all_users} 
                                onChange={() => this.ChangeListInView('all_users')}/>
                            <br/>    
                            <h6>All Users</h6>
                        </Col>
                        <Col>
                            <Input type="checkbox" checked={this.state.trainers} 
                                onChange={() => this.ChangeListInView('trainers')}/>
                            <br/>    
                            <h6>Trainers</h6>
                        </Col>
                        <Col>
                            <Input type="checkbox" checked={this.state.admins} 
                                onChange={() => this.ChangeListInView('admins')}/>
                            <br/>    
                            <h6>Admins</h6>
                        </Col>
                        <Col>
                            <Input type="checkbox" checked={this.state.basic_plan_users} 
                                onChange={() => this.ChangeListInView('basic_plan_users')}/>
                            <br/>    
                            <h6>Users on the basic plan</h6>
                        </Col>
                    </Row>
                    <br/><br/>
                    <Row style={{textAlign: 'left'}}>
                        <Col xs='3'>
                            <h6>
                                {label}:
                            </h6>
                        </Col>
                        <Col>
                            <h5>
                                {users_to_list.length}
                            </h5>
                        </Col>
                    </Row>
                    <br/>
                    <Table>
                        <thead>
                            <tr style={{fontSize: '15px'}}>
                                <th width='10%'>Firstname</th>
                                <th width='10%'>Lastname</th>
                                <th width='10%'>Email</th>
                                <th width='10%'>Phone</th>
                                <th width='10%'>Date Joined</th>
                                {
                                    label === 'Users on Basic Plan' 
                                    ?<>
                                        <th width='15%'>Schedule</th>
                                        <th width='15%'>Goals</th>
                                        <th width='15%'>Training Methods</th>
                                    </>
                                    : <>

                                    </>
                                }
                                <th width='20%'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {user_list}
                        </tbody>
                    </Table>
                </Container>

            }else if(current_render == 'withdrawal_requests'){
                var withdrawal_requests = this.state.withdrawal_requests.map((request, index) => {
                    return<tr style={{borderBottom: '1px solid #1faced'}}>
                        <td>{request.amount}</td>
                        <td>{request.email}</td>
                        <td>{request.request_date}</td>
                        <td>{request.processed.toString()}</td>
                        <td>{request.processed_date}</td>
                        <td>
                            <Button onClick={() => this.ApproveRequest(request._id.$oid)} style={{border: 'none', backgroundColor: '#1faced', color: '#ffffff', minWidth: '40%', borderRadius: '20px'}}>
                                Processed
                            </Button>
                        </td>
                    </tr>
                })

                return <Container>
                    <Table>
                        <thead>
                            <tr>
                                <th width='15%'>Amount</th>
                                <th width='15%'>Paypal Email</th>
                                <th width='15%'>Request Date</th>
                                <th width='15%'>Processed</th>
                                <th width='15%'>Date Processed</th>
                                <th width='15%'>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {withdrawal_requests}
                        </tbody>
                    </Table>
                </Container>
            }else{
                return<div>
                    <br/>
                    <Row>
                        <Col>
                            <h5 style={{marginTop: '60px', textAlign: 'center', marginBottom: '400px'}}>
                            Something went wrong, please try opening this section again.
                            </h5>
                        </Col>
                    </Row>
                </div>
            }
        }

        this.ApproveRequest = (request_id) => {
            this.setState({loading: true})
            const { cookies } = this.props;
            var data = new FormData()
            data.append('user_access_token', cookies.get('token'))
            data.append('request_id', request_id)

            if (window.confirm('Are you sure you want to mark this withdrawal as processed?')){
                axios.post(Backend_Url + 'processWithdrawalRequest', data)
                .then((res) => {
                    let result = res.data
                    alert('Withdrawal marked as processed. Refreshing list.')
                    this.GetWithdrawalRequests()
                    this.setState({loading: false})
                }).catch((error) => {
                    console.log(error)
                    this.setState({loading: false})
                })
            }else{
                console.log('cancelled')
                this.setState({loading: false})
            }
        }

        this.DeleteAccount = (account_id) => {     
            const { cookies } = this.props;
            this.setState({loading: true})
    
            var data = new FormData()
            data.append('user_access_token', cookies.get('token'))
            data.append('account_id', account_id)
            
            if (window.confirm('Are you sure you want to delete this account?')){
              axios.post(Backend_Url + 'deleteAccount', data)
              .then((res) => {
                  let result = res.data
                  if (result == 'Not authorized'){
                    alert('You are not authorized to perform this action.')
                    this.setState({loading: false})
                  }else{
                    var logged_user_id = this.state.user_details._id.$oid
                    if (logged_user_id == account_id) {
                        cookies.remove('token', { path: '/' });
                        alert('The deleted account is the one you were using. Signing you out.')
                        let port = (window.location.port ? ':' + window.location.port : '');
                        window.location.href = '//' + window.location.hostname + port + '/signin';
                    }else{
                        alert('Account deleted successfully. Refreshing user list.')
                        this.GetAllUsers()
                    }

                    this.setState({loading: false})
                  }
              }).catch((error) => {
                  console.log(error)
                  alert('Something went wrong, please try again.')
                  this.setState({loading: false})
              })
            }else{
              console.log('deletion cancelled.')
              this.setState({loading: false})
            }
        }

        this.GetAllUsers = () => {
            const { cookies } = this.props;
            var data = new FormData()
            data.append('user_access_token', cookies.get('token'))
    
            axios.post(Backend_Url + 'allUsers', data)
            .then((res) => {
                let result = res.data
                this.setState({users: result})
            }).catch((error) => {
                console.log(error)
            })
        }

        this.GetWithdrawalRequests = () => {
            const { cookies } = this.props;
            var data = new FormData()
            data.append('user_access_token', cookies.get('token'))
    
            axios.post(Backend_Url + 'getWithdrawalRequestsAdmin', data)
            .then((res) => {
                let result = res.data
                this.setState({widthdrawal_requests: result, loading: false})
            }).catch((error) => {
                console.log(error)
            })
        }
    }   

    componentDidMount() {
        window.scrollTo(0, 0)
        this.GetAllUsers()
        this.GetWithdrawalRequests()
    }




    render() {
        if (this.state.loading == true){
            return<Row>
                <Helmet>
                    <title>Admin Dashboard - ONFIT</title>
                    {/* <meta name="description" content="" /> */}
                </Helmet>
                <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
                <Container style={{textAlign: 'center', alignItems: 'center', justifyContent: 'center'}}>
                    <br/>
                    <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                    ONFIT
                    </h1>
                    <br/><br/>
                    <Triangle
                        color="#1FACED"
                        height={130}
                        width={130}
                    />
                    <h3 style={{marginTop: '50px', color: '#1FACED'}}>
                    Loading...
                    </h3>
                    <h6 style={{marginTop: '50px'}}>
                        Taking too long to load? Check your internet connection and reload the page.
                    </h6>
                    <br/><br/>
                </Container>
                </div>
            </Row>
        }

    return (
        <Row>
            <Helmet>
                <title>Admin Dashboard - ONFIT</title>
                {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundColor: '#ffffff', opacity: 0.9, width: '100%', minHeight: '1000px'}}>
                <br/>
                <h4 style={{}}>
                Admin Dashboard
                </h4>
                <br/>
                <Container>
                    <Row style={{marginRight: '0px', textAlign: 'left'}}>
                        <Col sm='3'>
                            <Button onClick={() => this.ChangeRender('upload_video')} style={{color: 'inherit', backgroundColor: 'inherit', border: '1px solid #1faced'}}>
                                Upload Video
                            </Button>
                        </Col>
                        <Col sm='3'>
                            <Button onClick={() => this.ChangeRender('analytics')} style={{color: 'inherit', backgroundColor: 'inherit', border: '1px solid #1faced'}}>
                                Analytics
                            </Button>
                        </Col>
                        <Col sm='3'>
                            <Button onClick={() => this.ChangeRender('user_lists')} style={{color: 'inherit', backgroundColor: 'inherit', border: '1px solid #1faced'}}>
                                User Lists
                            </Button>
                        </Col>
                        <Col sm='3'>
                            <Button onClick={() => this.ChangeRender('withdrawal_requests')} style={{color: 'inherit', backgroundColor: 'inherit', border: '1px solid #1faced'}}>
                                Withdrawal Requests
                            </Button>
                        </Col>
                    </Row>
                    <br/><br/><br/><br/><br/>
                    <this.SelectRender/>
                </Container>
                <br/><br/><br/>
            </div>
        </Row>
        );
    }

  };
  
  export default withCookies(PersonalTrainers);